import React from 'react';
import ReactDOM from 'react-dom';
import { FavoriteStorage } from '../../Util/FavoriteStorage';
import { VmsFavoriteToggler } from '../../Vms/VmsFavoriteToggler';
import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import VariableMessageSign from '../PopupTemplates/VariableMessageSign';
import { VariableMessageSignSource } from '../Sources/VariableMessageSign';

export function variableMessageSign(region: string, options?: ClusteredMarkerLayerOptions): ClusteredMarkerLayer {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: 'Trafikinformationsskylt',
        itemPlural: 'trafikinformationsskylt',
        source: new VariableMessageSignSource(undefined, { updateInterval: 60 }),
        popupTemplate: VariableMessageSign,
        popupOptions: {
            maxWidth: 250,
        },
        onPopupOpen: (e) => {
            setTimeout(function () {
                ReactDOM.render(
                    React.createElement(VmsFavoriteToggler, { currentVmsId: e.target.feature.id.toString(), currentRegion: 'vst' }),
                    document.getElementById('popup-favorite-toggler'),
                );
            }, 200);
        },
        defaultFilter: {
            filterFn: (features) => {
                const key = 'MySignPages' + region.toUpperCase();
                const favorites = new FavoriteStorage(key).getFavorites();
                return features.filter((feature) => favorites.indexOf(feature.id.toString()) > -1);
            },
            order: -1,
        },
    };

    return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
}
